import { Cell } from '@table-library/react-table-library/table';
import { showPlatform } from '../../../PromptManager/keys';
import { AI_TOOLS } from '../../../configs';
import DomainImage from '../../../../../components/DomainImage';
import Prompts from '../../../projects/components/prompts';

export const COLUMNS = (t) => [
    {
        label: t('ai_tracking.keyword_detail.urls.columns.url'),
        key: 'url',
        data: 'url',
        Component: Cell,
        sortType: 'string',
        cellSize: 'minmax(250px, 2.5fr)',
        renderCell: ({ data, item, csvDownload }) => {
            if (csvDownload) return item.url;
            return (
                <div>
                    <strong className="wrap-text">
                        {item.title === 'None' ? getName(data) : item.title}{' '}
                        <a
                            target="_blank"
                            className="link-website d-inline-flex align-items-center justify-content-center"
                            href={data}
                            rel="noreferrer"
                        >
                            <i className="icon-external-link"></i>
                        </a>
                    </strong>
                    <div className="text-sm">{data}</div>
                </div>
            );
        },
    },
    {
        label: t('ai_tracking.keyword_detail.urls.columns.domain'),
        key: 'domain',
        data: 'domain',
        Component: Cell,
        cellSize: 'minmax(180px, 1.8fr)',
        sortType: 'string',
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return item.domain;
            return (
                <div>
                    <strong className="wrap-text d-flex align-items-center">
                        <DomainImage domain_name={item.domain} className="domain_img" />
                        <span>{item.domain}</span>
                    </strong>
                </div>
            );
        },
    },
    {
        label: 'Prompt',
        key: 'prompt',
        data: 'prompt',
        Component: Cell,
        className: 'w-100',
        cellSize: 'minmax(180px, 1.8fr)',
        style: () => {
            return { width: '100%' };
        },
        renderCell: ({ item, csvDownload }) => {
            const shownData = item.prompts ? (
                <Prompts
                    project={{}}
                    count={1}
                    trancuateSize={27}
                    showShortPrompts
                    noLink
                    data={item.prompts?.split(',')?.map((item) => ({ prompt: item }))}
                />
            ) : (
                t('ai_tracking.projects.labels.noData')
            );

            if (csvDownload) return shownData;

            return (
                <div className="d-flex gap-8 justify-content-between w-100">
                    <div className="w-100">{shownData}</div>
                </div>
            );
        },
    },
    {
        label: 'No. Prompts',
        key: 'no_prompts',
        data: 'no_prompts',
        Component: Cell,
    },
    {
        label: t('ai_tracking.keyword_detail.urls.columns.platforms'),
        key: 'platforms',
        data: 'platforms',
        Component: Cell,
        sortType: 'string',
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            const platforms = data?.split(',') || [];
            return (
                <div className="d-flex flex-wrap gap-4">
                    {Object.keys(AI_TOOLS).map((state) => (
                        <div
                            key={state}
                            title={AI_TOOLS[state]}
                            className={`ai-tracking-platform-2 no-clickable ${
                                platforms?.includes(state) ? '' : 'disabled'
                            }`}
                        >
                            {showPlatform(state)}
                        </div>
                    ))}
                </div>
            );
        },
    },
    {
        label: t('ai_tracking.keyword_detail.urls.columns.rankingShare'),
        key: 'ranking_share',
        data: 'ranking_share',
        Component: Cell,
        sortType: (array) =>
            array.sort((a, b) => a.rankings / a.totalRuns - b.rankings / b.totalRuns),
        renderCell: ({ item }) => {
            if (!item.totalRuns) return t('ai_tracking.keyword_detail.urls.labels.noData');
            const value = (item.rankings / item.totalRuns) * 100;
            return `${value?.toFixed(2)} %`;
        },
    },
    {
        label: t('ai_tracking.keyword_detail.urls.columns.avgPosition'),
        key: 'avgPosition',
        data: 'avgPosition',
        Component: Cell,
        renderCell: ({ data }) => {
            return data?.toFixed(2);
        },
    },
    {
        label: t('ai_tracking.keyword_detail.urls.columns.uniqueTitles'),
        key: 'uniqueTitles',
        data: 'uniqueTitles',
        Component: Cell,
    },
];

function getName(url) {
    try {
        const parsedUrl = new URL(url);
        const parts = parsedUrl.pathname.split('/').filter(Boolean); // remove empty parts like ""
        return parts.length ? parts[parts.length - 1] : '';
    } catch (error) {
        return url;
    }
}
